import axiosClient from './axiosClient';

export interface TemplateSummary {
  id: string;
  name: string;
  description?: string;
  category?: string;
  status?: 'active' | 'inactive' | string;
  sizeKb?: number;
  variables?: string[];
  createdAt?: string;
  updatedAt?: string;
  // Propiedades del API externo
  file_size?: number;
  variables_detected?: string[];
  created_at?: string;
  updated_at?: string;
  settings?: {
    is_direct_upload?: boolean;
    variable_syntax?: any;
    [key: string]: any;
  };
}

export interface TemplatesResponse {
  data: TemplateSummary[];
  total?: number;
  stats?: {
    totalTemplates?: number;
    active?: number;
    storageUsedKb?: number;
    categories?: number;
  };
}

function mapExternalToTemplateSummary(item: any): TemplateSummary {
  return {
    id: item.id,
    name: item.name,
    description: item.description,
    category: item.category,
    status: item.status,
    sizeKb: item.file_size ?? item.sizeKb,
    variables: item.variables_detected ?? item.variables,
    createdAt: item.created_at ?? item.createdAt,
    updatedAt: item.updated_at ?? item.updatedAt,
    // Propaga directamente settings para saber si permite subida directa
    settings: item.settings,
  };
}

export async function fetchTemplates(params?: Record<string, any>): Promise<TemplatesResponse> {
  // Intenta ir directamente al servicio de informes usando el perfil activo (no el por defecto)
  try {
    // Obtener el perfil activo (usa el activo si existe, sino el por defecto)
    const { getActiveConfigProfile } = await import('./configProfiles');
    const prof = await getActiveConfigProfile();
    const apinformesUrl: string | undefined = prof?.apinformesUrl || undefined;
    if (apinformesUrl) {
      const base = apinformesUrl.replace(/\/$/, '');
      const url = new URL(base + '/api/templates');
      if (params) Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') url.searchParams.set(k, String(v)); });
      const resp = await fetch(url.toString(), { method: 'GET' });
      const raw = await resp.json();
      const list: any[] = Array.isArray(raw?.data) ? raw.data : Array.isArray(raw) ? raw : [];
      const mapped: TemplateSummary[] = list.map(mapExternalToTemplateSummary);
      const total = raw?.pagination?.total ?? raw?.count ?? mapped.length;
      return { data: mapped, total };
    }
  } catch {}

  // Fallback: a través del backend core (si existe un proxy)
  const response = await axiosClient.get('/api/templates', { params });
  const raw = response.data;
  const list: any[] = Array.isArray(raw?.data) ? raw.data : Array.isArray(raw) ? raw : [];
  const mapped: TemplateSummary[] = list.map(mapExternalToTemplateSummary);
  const total = raw?.pagination?.total ?? raw?.count ?? mapped.length;
  return { data: mapped, total } as TemplatesResponse;
}


